export enum DividerStyle {
  Solid = 'false',
  Dashed = 'true'
}
